module.exports = __webpack_public_path__ + "static/media/logo-colored.5fa3d277.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-colored.svg
// module id = 1397
// module chunks = 1